// extracted by mini-css-extract-plugin
export var loadingSpinner = "_52-1";
export var standaloneTable = "_52-0";